'use client'

import type { userAgent } from 'next/server'
import { createContext, useContext } from 'react'

type UserAgent = ReturnType<typeof userAgent>

const UserAgentContext = createContext({
  userAgent: null as UserAgent | null,
})

export function UserAgentProvider(props: {
  userAgent: UserAgent | null
  children: React.ReactNode
}) {
  return (
    <UserAgentContext.Provider value={{ userAgent: props.userAgent }}>
      {props.children}
    </UserAgentContext.Provider>
  )
}

export function useUserAgent() {
  const context = useContext(UserAgentContext)
  if (!context) {
    throw new Error('useUserAgent must be used within a UserAgentProvider')
  }
  return context.userAgent
}

export function useIsBot() {
  const userAgent = useUserAgent()
  return userAgent?.isBot ?? false
}
